export const getBalance = (state) => state?.wallet?.balance || {};
